/* eslint-disable import/prefer-default-export */
export const GET_CUSTOMER_DATA_HISTORY_URL = `https://slot.tizeti.com/geniatechapi/index.php`;
